<template lang="pug">
.sn-wrap(v-if="$route.params.id_match" :style="{'top': collapsedHeight}")
	.sn-subwrap.sn-subwrap--pri
		span {{ isMatchLiveReady }}
		.sn
			//- Pre-game
			router-link.sn__item(
				:to="{ name: $store.state.general.lang + '.prematch', params: { id_match: $route.params.id_match }}"
				:class="{'sn__item--sel': currentUrl.includes('prematch')}"
			)
				span {{ $t("pre_match_nav") }}

			//- Overview
			router-link.sn__item(
				:to="isMatchLiveReady ? { name: $store.state.general.lang + '.overview', params: { id_match: $route.params.id_match }} : ''"
				:class="{'sn__item--sel': currentUrl.includes('overview'),'sn__item--disabled': !isMatchLiveReady}"
			)
				span {{ $t("overview_nav") }}

			//- Stats
			router-link.sn__item(
				:to="isRoasterReady ? { name: $store.state.general.lang + '.stats', params: { id_match: $route.params.id_match }} : ''"
				:class="{'sn__item--sel': isStat, 'sn__item--disabled': !isRoasterReady}"
				)
				span {{ $t("stats_nav") }}


			//- Play by play
			router-link.sn__item(
				:to="isMatchLiveReady ? { name: $store.state.general.lang + '.playbyplay', params: { id_match: $route.params.id_match }} : ''"
				:class="{'sn__item--sel': currentUrl.includes('playbyplay'),'sn__item--disabled': !isMatchLiveReady}"
			)
				span {{ $t("playbyplay_nav") }}

	.sn-subwrap.sn-subwrap--sec(v-if="isStat")
		.sn
			//-Boxscore
			router-link.sn__item(
				:to="isRoasterReady ? { name: $store.state.general.lang + '.boxscore', params: { id_match: $route.params.id_match }} : ''"
				:class="{'sn__item--sel': currentUrl.includes('boxscore'),'sn__item--disabled': !isRoasterReady}"
			)
				span {{ $t("boxscore_nav") }}

			//-Leaders
			router-link.sn__item(
				:to="isMatchLiveReady ? { name: $store.state.general.lang + '.leaders', params: { id_match: $route.params.id_match }} : ''"
				:class="{'sn__item--sel': currentUrl.includes('leaders'),'sn__item--disabled': !isMatchLiveReady}"
				)
				span {{ $t("leaders_nav") }}

			//-Globals
			router-link.sn__item(
				:to="isMatchLiveReady ? { name: $store.state.general.lang + '.globals', params: { id_match: $route.params.id_match }} : ''"
				:class="{'sn__item--sel': currentUrl.includes('globals'),'sn__item--disabled': !isMatchLiveReady}"
				)
				span {{ $t("globals_nav") }}

			//-Shootmap
			router-link.sn__item(
				:to="isMatchLiveReady ? { name: $store.state.general.lang + '.shootmap', params: { id_match: $route.params.id_match }} : ''"
				:class="{'sn__item--sel': currentUrl.includes('shootmap'),'sn__item--disabled': !isMatchLiveReady}"
				)
				span {{ $t("shootmap_nav") }}


</template>

<style lang="sass">

.sn
	display: flex
	flex-direction: row
	justify-content: space-around
	max-width: 350px
	width: 100%
	&-wrap
		display: flex
		flex-direction: column
		box-shadow: 0 0 2px 0px $black
		//-position: sticky
		z-index: 1
		&:after
			content: ""
			position: absolute
			background-color: $black
			width: 100%
			height: 300px
			top: 0
			transform: translateY(-100%)
	&-subwrap
		display: flex
		justify-content: center
		&--pri
			height: 35px
			background-color: $black

		&--sec
			background-color: $white
			height: 30px
				
	&__item
		padding: 0.6rem 0.5rem
		text-transform: uppercase
		color: $white
		cursor: pointer
		text-decoration: none
		border: 0
		
		&--sel
			border-bottom: 3px solid $orange
			font-weight: $bold
			color: $orange

		
		@at-root .sn-subwrap--sec &
			color: $black
			padding: 0.3rem 0.5rem
			&--sel
				color: $orange


		&--disabled
			color: $light-grey
			cursor: default
			font-weight: $regular
			&:hover
				color: $light-grey

			@at-root .sn-subwrap--sec &
				color: $grey
				padding: 0.3rem 0.5rem
				&:hover
					color: $grey


		// &:not(.sn__item--disabled)
		// 	@media (hover: hover) and (pointer: fine)
		// 		&:hover
		// 			color: $orange


</style>

<script>

export default {
	name: "SubNav",
	computed: {
		collapsedHeight() {
			return `${this.$store.state.general.collapsedHeight}px`
		},
		currentUrl() {
			return this.$route.name.split('.')
		},
		isStat() {
			return ['boxscore', 'leaders', 'globals', 'shootmap'].includes(this.currentUrl[1])
		},
		isMatchLiveReady() {
			return (this.$store.state.match.status == "playing" || this.$store.state.match.status == "finished")
		},
		isRoasterReady() {
			return (this.$store.state.match.status == "roaster-ready" || this.$store.state.match.status == "playing" || this.$store.state.match.status == "finished")
		},

	},

}


</script>